<template>
  <NuxtLink
    :to="data.link?.cached_url && toLocalePath(data.link.cached_url)"
    :target="isTargetBlank ? '_blank' : '_self'"
    :aria-label="buttonAriaLabel"
    class="not-responsive inline-block bg-white px-3.5 py-2 text-sm leading-none tracking-widest shadow-smooth transition hover:bg-gray md:px-5 md:py-3.5 md:text-base"
  >
    {{ data.button_text }}
    <span v-if="buttonHiddenContext" class="sr-only">
      {{ buttonHiddenContext }}
    </span>
    <span v-if="isTargetBlank" class="sr-only">
      {{ getTargetBlankLabel(data.button_text || '', $t) }}
    </span>
  </NuxtLink>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import useRouteHelpers from '#layers/base/composables/useRouteHelpers'
import type { SbStageSlide } from '~/cms/storyblok/types/storyblok.d.ts'
import { getTargetBlankLabel } from '#layers/base/utils/a11y'

const { toLocalePath } = useRouteHelpers()

const props = defineProps<{ data: SbStageSlide }>()

const isTargetBlank = computed(() => props.data.cta_button?.[0]?.openNewTab)

const buttonDestinationLabel = computed(() => {
  const url = props.data.link?.cached_url || ''
  const [path = ''] = url.split('?')
  const [slug = ''] = path.split('/').filter(Boolean).slice(-1)

  return slug
    .split('-')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ')
})

const buttonHiddenContext = computed(() => {
  const label = props.data.button_text?.trim() || ''

  if (!label || !/^(mehr|more)$/i.test(label)) {
    return ''
  }

  const destination = buttonDestinationLabel.value

  return destination ? ` ${destination}` : ''
})

const buttonAriaLabel = computed(
  () =>
    `${props.data.button_text || ''}${buttonHiddenContext.value}`.trim() ||
    undefined,
)
</script>
